import React from "react";
import {ToastContainer} from "react-toastify";
import { Routers } from "./root";

const App = () => {
  return (
    <div className="app-wrapper">
      <div className="app-box">
        <Routers />
      </div>
        <ToastContainer position="bottom-right" />
    </div>
  );
};

export default App;
